<template>
  <CollapsibleCard
    :value="true"
    :padding="false"
    collapsibleIcon="mdi-order-bool-ascending-variant"
    collapsibleTitle="Sjekklister"
    :total="total"
  >
    <template v-slot>
      <div class="caseCardContainer" v-for="(item, index) in data" :key="index">
        <CaseCard
          :tile="true"
          :elevation="0"
          :title="item.name"
          :status="item.status"
          :color="getColor(item)"
          :chips="getChips(item)"
          :deadline="item.deadline"
          :underLeft="item.projectName"
          :underRight="item.assignedTo"
          @click="goToChecklist(item)"
        >
          <template v-slot:underLeft>
            {{ item.projectName }}
            {{ item.projectName && item.houseName ? "-" : "" }}
            {{ item.houseName }}
          </template>
        </CaseCard>
      </div>
      <ShowCollapsibleCardBtns
        :projectId="projectId"
        :houseName="houseName"
        filterNameProject="projTable"
        filterNameHouse="houseName"
        routeName="Checklists"
      />
    </template>
  </CollapsibleCard>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters } from "vuex";
import checkListApi from "@/api/checkListApi";

import CollapsibleCard from "@/components/shared/cards/CollapsibleCard.vue";
import ShowCollapsibleCardBtns from "@/components/shared/cards/ShowCollapsibleCardBtns.vue";
import CaseCard from "@/components/shared/cards/CaseCard.vue";

export default Vue.extend({
  name: "DashboardChecklists",
  props: {
    projectId: {
      default: "",
    },
    houseId: {
      default: null,
    },
    houseName: {
      default: null,
    },
  },
  data() {
    return {
      data: [],
      total: 0,
      loading: true,
    };
  },
  async mounted() {
    await this.fetchData();
    this.$watch(
      () => this.$route.params,
      () => {
        // react to route changes...
        this.fetchData();
      }
    );
  },
  methods: {
    async fetchData() {
      var headers = [
        {
          text: "Fullført",
          value: "isCompleted",
          type: "boolean",
          show: true,
          filterValues: ["false"],
          filterClause: 0,
          filterName: "isCompleted",
        },
        {
          text: "Frist",
          value: "deadline",
          type: "date",
          show: true,
          filterValues: "",
          filterClause: 0,
          filterName: "deadline",
          dateType: "DD.MM.YYYY",
        },
        {
          text: "Ansvarlig",
          value: "assignedTo",
          type: "string",
          show: true,
          filterValues: [this.profile.id],
          filterClause: 0,
          filterName: "assignedContactPersonId",
        },
        {
          filterName: "projTable",
          filterValues: this.projectId ? [this.projectId] : "",
          show: true,
          type: "string",
        },
        {
          filterName: "projPhase",
          filterValues: this.houseId ? [this.houseId] : "",
          show: true,
          type: "string",
        },
      ];

      var data = {
        headers: headers,
        itemsPerPage: 3,
        page: 1,
        search: "",
        sortBy: ["deadline"],
        sortDesc: [false],
        hideLoader: true,
      };

      await checkListApi
        .getChecklists(data)
        .then((response: any) => {
          this.data = response.items;
          this.total = response.totalItemCount;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    goToChecklist(item) {
      this.$router.push({ name: "checklist", params: { id: item.id } });
    },
    getChips(item: any) {
      var data = [
        {
          title:
            item.itemsCompletedCount + "/" + item.itemsTotalCount + " Fullført",
          color:
            item.itemsCompletedCount === item.itemsTotalCount
              ? "success"
              : "warning",
        },
        {
          title: item.completedDate ? "Fullført" : "Ikke fullført",
          color: item.completedDate ? "success" : "warning",
        },
      ];

      return data;
    },
    getColor(item) {
      if (item?.color) {
        return item.color;
      } else if (item) {
        this.$set(item, "color", item.completedDate ? "success" : "warning");
      }
    },
  },
  computed: {
    ...mapGetters({
      profile: "shared/profile",
    }),
  },
  components: {
    CollapsibleCard,
    ShowCollapsibleCardBtns,
    CaseCard,
  },
});
</script>
